<template>
<div class="row">
  <div class="col-sm-6">
   </div>
  <div class="table-responsive">
    
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Tienda</th>
          <th>Tienda a Pedir</th>
          <th>Usuario</th>
          <th>Fecha</th>
          <th>Fecha Ultima Edición</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="current in dataTabla.results" v-bind:key="current.id" @click="generar_salida(current)">
          <td>{{ current.numero }}</td>
          <td>{{ current.tienda.nombre }}</td>
          <td>{{ current.tienda_pedir.nombre }}</td>
          <td>
            <UsuarioEnTablaComponent :current="current.usuario" />
          </td>
          <td>{{ current.fecha }}</td>
          <td>
            <timeago :title="current.fecha_creacion" :datetime="current.fecha_creacion"></timeago>
          </td>
          <td class="text-center">
            <div data-title="Activo" data-toggle="tooltip" v-html="current.estado_str"></div>
          </td>
          <td class="text-center">
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
    <PaginationComponent :currentPage="currentPage" :data="dataTabla" @pagechanged="onPageChange" />
  </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";

import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import OrdenCompraService from "@/services/compras/OrdenCompraService";
import Notifications from "@/notifications/notifications";
import ReqTrasladoService from "@/services/inventario/ReqTrasladoService";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent
  },
  data() {
    return {
      dataTabla: "",
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: []
    };
  },
  computed: {
    ...mapGetters({
    })
  },
  mounted() {
    let self = this;
    this.$store.dispatch("reqtraslado/fetch");
    self.refreshData();
  },
  methods: {

    refreshData() {
      let self = this;
      ReqTrasladoService.fetch().then(res => {
        self.dataTabla = res.data;
      });
    },

    generar_salida(current) {
      let self = this;
      Notifications.alert.confirm(
        "Generar Salida de Producto a partir de un Requerimiento de Traslado",
        "¿Desea Generar una salida de bodega a partir de este requerimiento de traslado?",
        "Si, Generar",
        function() {
          ReqTrasladoService.generar_salida(current.id)
            .then((response) => {
              Notifications.alert.confirm(
                "Requerimiento de Traslado",
                "Ir a la Salida Generada #.",
                "",
                function() {
                  self.$router.push({
                    name: "inventario-salida_traslado-editar",
                    params: { id: response.data.salida_traslado_e },
                  });
                  document.location.reload();
                }
              );
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.salida_traslado_d
                );
              }
            });
        }
      );
    },
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("ordencompra/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext
      });
    },
    irAEsconderModal(name, params) {
      if($('.modal').hasClass('show')){
        $('.modal').find('.close').click();
      }
      this.$router.push({
        name: name,
        params: params
      });
    },
    generar_entrada_compra(current) {
      let self = this;
      OrdenCompraService.generar_entrada_compra(current.id)
        .then(response => {
          Notifications.alert.confirm(
            "Entrada de prodcuto",
            "Ir a la Entrada Generada",
            "",
            function() {
            document.location.reload();
            }
          );
        })
          .catch((error) => {
            Notifications.alert.error(
              "No se ha podido realizar la acción",
               error.response.data.detail
              );
            });
    },
  }
};
</script>

